import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { RolesService } from 'src/app/shared/service/roles.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(private rolesService: RolesService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isAdmin = this.rolesService.checkIfUserIsAdmin();
    const isPresalesEngineer = this.rolesService.checkIfUserIsPresalesEngineer();
    const isAccountManager = this.rolesService.checkIfUserIsAccountManger();
    if (isAdmin) {
      return true;
    } else if (
      isAccountManager &&
      (state.url.includes('tools/account-management') ||
        state.url.includes('tools/calculators') ||
        state.url.includes('tools/history'))
    ) {
      return true;
    } else if (
      isPresalesEngineer &&
      (state.url.includes('tools/account-management') ||
        state.url.includes('tools/calculators') ||
        state.url.includes('tools/history') ||
        state.url.includes('tools/marketing'))
    ) {
      return true;
    }

    this.router.navigate(['401']);
    return false;
  }
}
